import { render } from "./BrandPageList.vue?vue&type=template&id=05a3bd5a&scoped=true&ts=true"
import script from "./BrandPageList.vue?vue&type=script&lang=ts"
export * from "./BrandPageList.vue?vue&type=script&lang=ts"

import "./BrandPageList.vue?vue&type=style&index=0&id=05a3bd5a&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a3bd5a"]])

export default __exports__